export const CUBE_SIZE_SMALL = 'small' as const;
export const CUBE_SIZE_SMALL_CORNER = 'small-corner' as const;
export const CUBE_SIZE_TALL = 'tall' as const;
export const CUBE_SIZE_TALL_CORNER = 'tall-corner' as const;
export const CUBE_SIZE_WIDE = 'wide' as const;
export const CUBE_SIZE_LARGE = 'large' as const;

export type CubeSize =
		typeof CUBE_SIZE_SMALL |
		typeof CUBE_SIZE_SMALL_CORNER |
		typeof CUBE_SIZE_TALL |
		typeof CUBE_SIZE_TALL_CORNER |
		typeof CUBE_SIZE_WIDE |
		typeof CUBE_SIZE_LARGE;

export const CUBE_WIDTH_SMALL = 1322;
export const CUBE_HEIGHT_SMALL = 1319;
export const CUBE_WIDTH_TALL = 1322;
export const CUBE_HEIGHT_TALL = 1730;
export const CUBE_WIDTH_WIDE = 1698;
export const CUBE_HEIGHT_WIDE = 1385;
export const CUBE_WIDTH_LARGE = 1698;
export const CUBE_HEIGHT_LARGE = 1796;
export const CUBE_SMALL_2D_WIDTH = 1240;
export const CUBE_SMALL_2D_HEIGHT = 1240;
export const CUBE_WIDE_2D_WIDTH = 1806;
export const CUBE_WIDE_2D_HEIGHT = 1240;
export const CUBE_TALL_2D_WIDTH = 1240;
export const CUBE_TALL_2D_HEIGHT = 1806;
export const CUBE_LARGE_2D_WIDTH = 1806;
export const CUBE_LARGE_2D_HEIGHT = 1806;

export const SNAP_DIST = 36;

export const CUBE_SMALL_ISO = {
	width: 1322,
	height: 1319,
	tblX: 497 / 1322,
	tblY: 0,
	tbrX: 1,
	tbrY: 145 / 1319,
	tfrX: 826 / 1322,
	tfrY: 415 / 1319,
	tflX: 0,
	tflY: 271 / 1319,
	bblX: 497 / 1322,
	bblY: 904 / 1319,
	bbrX: 1,
	bbrY: 1049 / 1319,
	bfrX: 826 / 1322,
	bfrY: 1,
	bflX: 0,
	bflY: 1174 / 1319
};

export const CUBE_TALL_ISO = {
	width: 1322,
	height: 1730,
	tblX: 497 / 1322,
	tblY: 0,
	tbrX: 1,
	tbrY: 145 / 1730,
	tfrX: 826 / 1322,
	tfrY: 415 / 1730,
	tflX: 0,
	tflY: 271 / 1730,
	bblX: 497 / 1322,
	bblY: 1315 / 1730,
	bbrX: 1,
	bbrY: 1460 / 1730,
	bfrX: 826 / 1322,
	bfrY: 1,
	bflX: 0,
	bflY: 1586 / 1730
};

export const CUBE_WIDE_ISO = {
	width: 1698,
	height: 1385,
	tblX: 497 / 1698,
	tblY: 0,
	tbrX: 1,
	tbrY: 211 / 1385,
	tfrX: 1202 / 1698,
	tfrY: 481 / 1385,
	tflX: 0,
	tflY: 271 / 1385,
	bblX: 497 / 1698,
	bblY: 904 / 1385,
	bbrX: 1,
	bbrY: 1114 / 1385,
	bfrX: 1204 / 1698,
	bfrY: 1,
	bflX: 0,
	bflY: 1174 / 1385,
};

export const CUBE_LARGE_ISO = {
	width: 1698,
	height: 1796,
	tblX: 497 / 1698,
	tblY: 0,
	tbrX: 1,
	tbrY: 211 / 1796,
	tfrX: 1202 / 1698,
	tfrY: 481 / 1796,
	tflX: 0,
	tflY: 271 / 1796,
	bblX: 497 / 1698,
	bblY: 1315 / 1796,
	bbrX: 1,
	bbrY: 1527 / 1796,
	bfrX: 1204 / 1698,
	bfrY: 1,
	bflX: 0,
	bflY: 1586 / 1796,
};
